import React, { useState, useEffect, memo } from 'react';

import { Avatar, Grid, Divider } from '@material-ui/core';
import { RemoveShoppingCartOutlined, ShoppingCartOutlined } from '@material-ui/icons';

import { func, object, bool, string } from 'prop-types';
import { generate } from 'shortid';
import { withTheme } from 'styled-components';

import { formatMoney, mergeLinesKits, createProductLink } from '../../../../libs';
import { cartSummary } from '../../../../libs/cartSummary';
import { getCustomerCep } from '../../../../redux/utils/cookies';
import Button from '../../../Button';
import InfoMessage from '../../../InfoMessage';
import InputCep from '../../../InputCep';

import {
  ListCart,
  ListItemCart,
  CartText,
  ListItemAvatarStyled,
  CartTextName,
  MenuCart,
  StyledLink,
  GridButton,
  ListItem,
  GridPrices,
  ListItemPrices,
  Empty,
  Title,
} from './styles';

function HeaderCartMenu({
  cartFreightRequest,
  cartFreight,
  setAnchorEl,
  isLoading,
  anchorEl,
  inputId,
  domain,
  theme,
  error,
  cart,
  anchorOrigin,
  transformOrigin,
}) {
  const [value, setValue] = useState('');

  const { taxes, freight, total, temporary } = cartSummary(cart, cartFreight);

  const empty = cart.getIn(['sellers'], []).length <= 0;

  useEffect(() => {
    const customerCep = getCustomerCep(domain);

    if (customerCep) setValue(customerCep);
  }, [setValue, domain]);

  const handleChange = (ev) => {
    ev.preventDefault();
    setValue(ev.target.value.replace(/[-_]/g, ''));
  };

  const handleClick = () => {
    cartFreightRequest(value, { filter: 'lowerPrice' });
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <MenuCart
      id="fade-menu"
      keepMounted
      disableScrollLock
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={handleClose}
      getContentAnchorEl={null}
      anchorOrigin={
        anchorOrigin || {
          vertical: 'bottom',
          horizontal: 'center',
        }
      }
      transformOrigin={
        transformOrigin || {
          vertical: 'top',
          horizontal: 'center',
        }
      }
      empty={empty ? 'true' : null}
      variant="selectedMenu"
    >
      {empty && (
        <Empty>
          <RemoveShoppingCartOutlined />
          Carrinho vazio
        </Empty>
      )}
      {!empty && (
        <Title>
          <ShoppingCartOutlined />
          Carrinho
        </Title>
      )}
      {!empty && (
        <ListItem>
          <ListCart>
            {cart.getIn(['sellers'], []).map((seller) =>
              mergeLinesKits(seller.getIn(['lines']), seller.getIn(['kits'])).map((item) => (
                <ListItemCart key={`item-${generate()}`} divider>
                  <StyledLink
                    href={createProductLink(
                      item.getIn(['product', 'name']),
                      item.getIn(['product', 'base']),
                      item.getIn(['product', 'diffs'])
                    )}
                    title={item.getIn(['product', 'name'])}
                  >
                    <ListItemAvatarStyled>
                      <Avatar
                        variant="rounded"
                        src={
                          item.getIn(['product', 'image']) && item.getIn(['product', 'image']).replace('/200/', '/100/')
                        }
                      >
                        {item.getIn(['product', 'name'], '').match(/\w/)[0]}
                      </Avatar>
                    </ListItemAvatarStyled>
                    <CartTextName>{item.getIn(['product', 'name'])}</CartTextName>
                    <CartText padding="6px">{`${item.getIn(['quantity'])}un`}</CartText>
                    <CartText semibold width="85px" textalign="right">
                      {formatMoney(item.getIn(['salesPrice']), true, true)}
                    </CartText>
                  </StyledLink>
                </ListItemCart>
              ))
            )}
          </ListCart>
        </ListItem>
      )}

      {!empty && (
        <ListItemPrices>
          {cart.getIn(['products', 'showPrice']) && (
            <Grid container justifyContent="center">
              {error.cart && <InfoMessage message={error.message} type="error" />}
              <InputCep
                handleChange={handleChange}
                handleClick={handleClick}
                value={value}
                isLoading={isLoading}
                margin="dense"
                themecolor={theme.colors.primary}
                id={inputId}
              />
            </Grid>
          )}

          {cart.getIn(['products', 'showPrice']) && (
            <GridPrices container justifyContent="space-between">
              <CartText>{`${cart.getIn(['products', 'quantity'])} produto(s)`}</CartText>
              <CartText>{formatMoney(cart.getIn(['products', 'subtotal']), true, true)}</CartText>
            </GridPrices>
          )}

          {cart.getIn(['products', 'showPrice']) && taxes > 0 && (
            <GridPrices container justifyContent="space-between">
              <CartText>Impostos:</CartText>
              <CartText>{formatMoney(taxes)}</CartText>
            </GridPrices>
          )}

          {cart.getIn(['products', 'showPrice']) && typeof freight === 'number' && (
            <GridPrices container justifyContent="space-between">
              <CartText>Frete:</CartText>
              <CartText>{formatMoney(freight)}</CartText>
            </GridPrices>
          )}

          {cart.getIn(['products', 'showPrice']) && <Divider />}

          {cart.getIn(['products', 'showPrice']) && (
            <GridPrices container justifyContent="space-between">
              <CartText color="#000000" fontsize="15px" weight="bold">
                Total:
              </CartText>
              <CartText fontsize="15px" color="#000000" weight="bold">
                {formatMoney(total)}
                {!temporary && <span>à vista</span>}
              </CartText>
            </GridPrices>
          )}

          <Grid container spacing={1}>
            {cart.getIn(['products', 'showPrice']) && (
              <GridButton container item justifyContent="center" md={6} xs={12}>
                <Button
                  color={theme.colors.secondary}
                  width="100%"
                  height="33px"
                  href="/carrinho/checkout"
                  name="Fechar Pedido"
                />
              </GridButton>
            )}
            <GridButton container item justifyContent="center" md={6} xs={12}>
              <Button color={theme.colors.primary} width="100%" height="33px" href="/carrinho" name="Ver Carrinho" />
            </GridButton>
          </Grid>
        </ListItemPrices>
      )}
    </MenuCart>
  );
}

HeaderCartMenu.propTypes = {
  anchorEl: object,
  setAnchorEl: func,
  cart: object,
  cartFreightRequest: func,
  isLoading: bool,
  cartFreight: object,
  theme: object,
  error: object,
  inputId: string,
  domain: string,
  anchorOrigin: object,
  transformOrigin: object,
};

export default withTheme(memo(HeaderCartMenu));
